/**
 * Spanish word -> English meaning for teaching prompts.
 * Used for wrong-answer feedback and hints in Spanish levels.
 * Keys are lowercase; lookup uses word.toLowerCase() and we also try the word as-is for accents.
 */
export const spanishTranslations = {
  // Fruits
  manzana: 'apple',
  naranja: 'orange',
  plátano: 'banana',
  platano: 'banana',
  uva: 'grape',
  fresa: 'strawberry',
  sandía: 'watermelon',
  sandia: 'watermelon',
  melón: 'melon',
  melon: 'melon',
  pera: 'pear',
  durazno: 'peach',
  limón: 'lemon',
  limon: 'lemon',
  piña: 'pineapple',
  pina: 'pineapple',
  cereza: 'cherry',
  // Animals & common nouns
  gato: 'cat',
  perro: 'dog',
  casa: 'house',
  árbol: 'tree',
  arbol: 'tree',
  mesa: 'table',
  silla: 'chair',
  libro: 'book',
  agua: 'water',
  coche: 'car',
  sol: 'sun',
  luna: 'moon',
  estrella: 'star',
  caballo: 'horse',
  vaca: 'cow',
  cerdo: 'pig',
  pollo: 'chicken',
  pez: 'fish',
  pájaro: 'bird',
  pajaro: 'bird',
  ratón: 'mouse',
  raton: 'mouse',
  elefante: 'elephant',
  león: 'lion',
  leon: 'lion',
  tigre: 'tiger',
  flor: 'flower',
  ventana: 'window',
  puerta: 'door',
  camino: 'path',
  // Colors
  rojo: 'red',
  azul: 'blue',
  verde: 'green',
  amarillo: 'yellow',
  negro: 'black',
  blanco: 'white',
  morado: 'purple',
  rosa: 'pink',
  gris: 'grey',
  marrón: 'brown',
  marron: 'brown',
  café: 'brown',
  // Adjectives (colors rule incorrect answers)
  grande: 'big',
  pequeño: 'small',
  pequeno: 'small',
  rápido: 'fast',
  rapido: 'fast',
  lento: 'slow',
  feliz: 'happy',
  triste: 'sad',
  alto: 'tall',
  bajo: 'short',
  nuevo: 'new',
  viejo: 'old',
  caliente: 'hot',
  frío: 'cold',
  frio: 'cold',
  // Verbs (conjugations)
  hablan: 'they speak',
  comen: 'they eat',
  viven: 'they live',
  escriben: 'they write',
  leen: 'they read',
  corren: 'they run',
  bailan: 'they dance',
  cantan: 'they sing',
  trabajan: 'they work',
  estudian: 'they study',
  juegan: 'they play',
  cocinan: 'they cook',
  hablo: 'I speak',
  como: 'I eat',
  vivo: 'I live',
  escribo: 'I write',
  leo: 'I read',
  corro: 'I run',
  bailo: 'I dance',
  canto: 'I sing',
  trabajo: 'I work',
  estudio: 'I study',
  juego: 'I play',
  cocino: 'I cook',
  hablas: 'you speak',
  comes: 'you eat',
  vives: 'you live',
  escribes: 'you write',
  lees: 'you read',
  corres: 'you run',
  bailas: 'you dance',
  cantas: 'you sing',
  trabajas: 'you work',
  estudias: 'you study',
  juegas: 'you play',
  cocinas: 'you cook',
  hablamos: 'we speak',
  comemos: 'we eat',
  vivimos: 'we live',
  escribimos: 'we write',
  leemos: 'we read',
  corremos: 'we run',
  bailamos: 'we dance',
  cantamos: 'we sing',
  trabajamos: 'we work',
  estudiamos: 'we study',
  jugamos: 'we play',
  cocinamos: 'we cook',
  habláis: 'you (pl.) speak',
  hablais: 'you (pl.) speak',
  // Sports
  fútbol: 'soccer',
  futbol: 'soccer',
  béisbol: 'baseball',
  beisbol: 'baseball',
  baloncesto: 'basketball',
  tenis: 'tennis',
  natación: 'swimming',
  natacion: 'swimming',
  ciclismo: 'cycling',
  atletismo: 'athletics',
  voleibol: 'volleyball',
  hockey: 'hockey',
  golf: 'golf',
  boxeo: 'boxing',
  esquí: 'skiing',
  esqui: 'skiing',
  // Foods
  pan: 'bread',
  hamburguesa: 'hamburger',
  ensalada: 'salad',
  arroz: 'rice',
  pescado: 'fish',
  queso: 'cheese',
  leche: 'milk',
  huevos: 'eggs',
  fruta: 'fruit',
  verduras: 'vegetables',
  sopa: 'soup',
};

/**
 * Get English meaning for a Spanish word (for display in prompts).
 * Returns undefined if not found.
 */
export function getSpanishMeaning(spanishWord) {
  if (!spanishWord || typeof spanishWord !== 'string') return undefined;
  const key = spanishWord.trim().toLowerCase();
  return spanishTranslations[key] || spanishTranslations[spanishWord.trim()];
}

export default spanishTranslations;
